export default ['JsonRPCService', function (JsonRPCService) {
    return {
        hasUserPermission: function hasUserPermission(permission) {
            return JsonRPCService.send('pc', 'gateway/user', 'hasUserPermission', [permission]);
        },
        hasUserSystemPermission: function hasUserSystemPermission(permission) {
            return JsonRPCService.send('pc', 'gateway/user', 'hasUserSystemPermission', [permission]);
        },
        getAvailableProducerCodesForCurrentUser: function getAvailableProducerCodesForCurrentUser() {
            return JsonRPCService.send('pc', 'gateway/user', 'getAvailableProducerCodesForCurrentUser', []);
        },
        getProducerCodesAndGroupsForCurrentUser: function getProducerCodesAndGroupsForCurrentUser() {
            return JsonRPCService.send('pc', 'gateway/user', 'getProducerCodesAndGroupsForCurrentUser', []);
        },
        hasUserAccessToAccountPolicies: function hasUserAccessToAccountPolicies(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/user', 'hasUserAccessToAccountPolicies', [accountNumber]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/UserService.js
// module id = 1797
// module chunks = 0